







































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { useUtilityStore } from "@/admin/store/utility";

@Component({
  components: {
    Button,
    Input,
    ErrorSummary
  }
})
export default class AdminEmailChange extends Vue {
  $validator: Validator;

  utilityStore = useUtilityStore();

  fromEmail = "";
  toEmail = "";
  formInSubmit = false;

  onSubmit (e: Event) {
    e.preventDefault();
    this.$validator.validateAll()
      .then(isValid => {
        if (this.formInSubmit || !isValid) {
          return;
        }

        this.formInSubmit = true;
        this.doAdminEmailChange();
      });
  }

  doAdminEmailChange () {
    this.utilityStore.adminEmailChange({ fromEmail: this.fromEmail, toEmail: this.toEmail })
      .finally(() => {
        this.formInSubmit = false;
      });
  }
}

